import colors from 'styles/theme/colors';

export default function LocationPinIcon({
  width = 8,
  height = 8,
  color = colors.black100,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' width='7' height='8' viewBox='0 0 7 8' fill='none'>
        <path
          d='M3.50012 0C1.56804 0.00201492 0.00232638 1.4332 0.00012207 3.19928C0.00012207 4.85102 2.81962 7.55623 3.14112 7.86108C3.2353 7.94988 3.36482 8 3.50012 8C3.63542 8 3.76495 7.94988 3.85912 7.86108C4.18062 7.55623 7.00012 4.85102 7.00012 3.19928C6.99792 1.4332 5.4322 0.00201492 3.50012 0ZM3.50012 4.57039C2.67169 4.57039 2.00012 3.95652 2.00012 3.19928C2.00012 2.44203 2.67169 1.82816 3.50012 1.82816C4.32855 1.82816 5.00012 2.44203 5.00012 3.19928C5.00012 3.56292 4.84209 3.91167 4.56078 4.1688C4.27948 4.42594 3.89795 4.57039 3.50012 4.57039Z'
          fill={color}
          fillOpacity='0.75'
        />
      </svg>
    </svg>
  );
}
